// extracted by mini-css-extract-plugin
module.exports = {"videoPreview":"CreateEditTransitionModal_videoPreview__2Cidz","uploadProgress":"CreateEditTransitionModal_uploadProgress__10RYR"};